
import { computed, defineComponent, PropType, toRefs } from 'vue'
import { IdfIcon } from '@invivodf/ui-kit'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { Section } from '../../../domain/Section'
import { SectionName } from '../../../domain/SectionName'
import PParametersToggle, { ReactiveToggle } from '../PParametersToggle/PParametersToggle.vue'

export default defineComponent({
  name: 'PParametersList',
  components: { IdfIcon, PParametersToggle },
  props: {
    sections: {
      type: Array as PropType<Section[]>,
      required: true,
    },
    toggles: {
      type: Array as PropType<ReactiveToggle[]>,
      required: false,
      defaultValue: () => [],
    },
  },
  setup(props) {
    const { toggles } = toRefs(props)
    const i18n = useI18nForVue2()

    const getTranslatedSectionName = (sectionName: SectionName) => {
      const translations = {
        [SectionName.Transversal]: computed(() => i18n.t('ctx.parameters.transversal')),
        [SectionName.Product]: computed(() => i18n.t('ctx.parameters.products')),
        [SectionName.StockAndQuota]: computed(() => i18n.t('ctx.parameters.stock-and-quota')),
        [SectionName.Payment]: computed(() => i18n.t('ctx.parameters.payment')),
        [SectionName.Validation]: computed(() => i18n.t('ctx.parameters.validation')),
        [SectionName.Delivery]: computed(() => i18n.t('ctx.parameters.delivery')),
        [SectionName.Marketing]: computed(() => i18n.t('ctx.parameters.marketing')),
        [SectionName.Users]: computed(() => i18n.t('ctx.parameters.users')),
        [SectionName.Toggle]: computed(() => i18n.t('ctx.parameters.toggle')),
      }
      return translations[sectionName] || computed(() => '')
    }
    const togglesSectionName = getTranslatedSectionName(SectionName.Toggle)
    const hasToggles = computed(() => (toggles.value ?? []).some((item) => item.isAuthorized.value))

    return {
      getTranslatedSectionName,
      hasToggles,
      togglesSectionName,
    }
  },
})
